// QuickMenu.jsx
import React, { useState, useEffect } from 'react';

const QuickMenu = ({ topRef }) => {
  const [isVisible, setIsVisible] = useState(false);

  // topRef가 화면에서 보이는지 여부만 보고 버튼 표시/숨김 결정
  useEffect(() => {
    if (!topRef?.current) return;

    const target = topRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // topRef가 보이면 => 맨 위에 있는 거니까 버튼 숨김
        // topRef가 안 보이면 => 스크롤 내려온 거니까 버튼 표시
        setIsVisible(!entry.isIntersecting);
      },
      {
        root: null, // viewport 기준
        threshold: 0.1, // 10% 이상 보이면 "보이는 상태"로 판단
      }
    );

    observer.observe(target);

    return () => {
      observer.disconnect();
    };
  }, [topRef]);

  const scrollTop = () => {
    if (topRef?.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <button
      type="button"
      className={`quick-top-btn ${isVisible ? 'visible' : ''}`}
      onClick={scrollTop}
      aria-label="페이지 상단으로 이동"
    >
      <span className="quick-top-icon" />
      <span className="quick-top-text">TOP</span>
    </button>
  );
};

export default QuickMenu;
